export default "__VITE_ASSET__du$1shLZ__";